<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input v-model="getQuestionPaperList_data.qpName" placeholder="请输入试卷名" clearable size='small'
          style="max-width:380px;" />
        <el-select v-model='getQuestionPaperList_data.qtgId' @change="getList" size="small" clearable
          placeholder="请选择题目分组">
          <el-option v-for="item in getQuestionTopicGroupList_data.data || []" :key="item.qtgId" :label="item.qtgName"
            :value="item.qtgId">
          </el-option>
        </el-select>
        <el-select v-model='getQuestionPaperList_data.qpStatus' @change="getList2" size="small" clearable
          placeholder="请选择试卷状态">
          <el-option label="未发布" :value="1">
          </el-option>
          <el-option label="已发布" :value="2">
          </el-option>
          <el-option label="已暂停" :value="3">
          </el-option>
          <el-option label="已过期" :value="4">
          </el-option>
        </el-select>

        <el-button v-click.getQuestionPaperList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>
      <el-col :span="6">
        <el-button v-if="addQuestionPaper" @click=" $form('addQuestionPaper')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加试卷
        </el-button>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getQuestionPaperList' api='getQuestionPaperList' xupdateapi='updateQuestionPaper'
      :height="H - 165">
    </mytable>

    <myform width="80%" :viewobj='{
      addQuestionPaper: ["新增试卷信息", "el-icon-circle-plus"],
      updateQuestionPaper: ["修改试卷信息", "el-icon-edit-outline"],
      $succeed$: getQuestionPaperList
    }' @close='$form("addQuestionPaper", "reset")' @confirm='myform'>
      <hide slot='qpId' />

      <template v-slot:qpType="{ Myformdata }">
        <el-radio-group v-model="Myformdata.qpType" @input="theChangeRadio">
          <el-radio :label="1">常规</el-radio>
          <el-radio :label="2">微课</el-radio>
        </el-radio-group>
      </template>
      <template v-slot:qpTypeDo="{ Myformdata }">
        <el-radio-group v-model="Myformdata.qpTypeDo">
          <el-radio :label="1">考试</el-radio>
          <el-radio :label="2">练习</el-radio>
        </el-radio-group>
      </template>
      <template v-slot:microlectureId="{ Myformdata }">
        <el-input disabled v-if="theRadio != 2"></el-input>
        <el-select v-model="Myformdata.microlectureId" clearable v-if="theRadio == 2">
          <el-option v-for="item in getMicrolectureList_data.data || []" :key="item.microlectureId"
            :label="item.microlectureTitle" :value="item.microlectureId">
          </el-option>
        </el-select>
      </template>
      <template v-slot:qtgIds="{ Myformdata }">
        <el-select v-model="Myformdata.qtgIds" multiple clearable>
          <el-option v-for="item in getQuestionTopicGroupList_data.data || []" :key="item.qtgId" :label="item.qtgName"
            :value="item.qtgId">
          </el-option>
        </el-select>
      </template>
      <template v-slot:qpStartTime="{ Myformdata }">
        <el-date-picker v-model="Myformdata.qpStartTime" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间">
        </el-date-picker>
      </template>
      <template v-slot:qpEndTime="{ Myformdata }">
        <el-date-picker v-model="Myformdata.qpEndTime" type="date" value-format="yyyy-MM-dd" placeholder="选择截止时间">
        </el-date-picker>
      </template>
      <template v-slot:qpStatus="{ Myformdata }">
        <el-radio v-model="Myformdata.qpStatus" :label="1">未发布</el-radio>
        <el-radio v-model="Myformdata.qpStatus" :label="2">立即发布</el-radio>
      </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theRadio: '',
      theSelectedQtIds: "",

      array: [],
      tableColums_getQuestionPaperList: {
        $selection: false,

        qpName: '试卷名称',

        qpStatus: ['状态', , '@v-if: 1:未发布#danger, 2:已发布#success, 3:已暂停#info'],
        qpTypeDo: ['考试类型', , '@v-if: 1:考试#danger, 2:练习#success'],
        qpType: ['试卷类型', , '@v-if: 1:常规#danger, 2:微课#success'],
        qpAnswerTimes: '答卷人数',
        qtgName: '题目分组',
        qpNums: '题目数量',
        qpScorePass: '及格分数',
        qpStartTime: '开始时间',
        qpEndTime: '结束时间',
        upTime: '发布时间',

        createtime: '创建时间',
        microlectureTitle: '微课',

        $operation: [
          '操作', 200,
          this.updateQuestionPaper && `@text: 编辑#success
           @click: 
           handleEdit($row);
          
          `,
          this.updateQuestionPaperStatusUp && `@text: 发布#success
           @click: _confirm('确定要发布该试卷吗?')
                   .trigger('updateQuestionPaperStatusUp',{qpId:$row.qpId})
                   .trigger('getQuestionPaperList')
          `,
          this.updateQuestionPaperStatusDown && `@text: 暂停#success
           @click: _confirm('确定要暂停该试卷吗?')
                   .trigger('updateQuestionPaperStatusDown',{qpId:$row.qpId})
                   .trigger('getQuestionPaperList')
          `,
          this.deleteQuestionPaper && `@text: 删除#danger
           @click: _confirm('确定要删除该试卷吗?')
                   .trigger('deleteQuestionPaper',{qpId:$row.qpId})
                   .trigger('getQuestionPaperList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    handleEdit(row) {
      const theRow = JSON.parse(JSON.stringify(row))
      theRow.qtgIds = theRow.qtgIds.split(',');
      theRow.qtgIds.forEach((item, index) => {

        theRow.qtgIds[index] = parseInt(item)

      })
      this.$form("updateQuestionPaper", theRow);
       this.getQuestionPaperDetails({ qpId: row.qpId }).trigger(res => this.array = (res.data.data || 0).questionTopicList);

    },
    theChangeRadio(e) {
      this.theRadio = e
    },
    getList(e) {
      this.getQuestionPaperList({ qtgId: e })
    },
    getList2(e) {
      this.getQuestionPaperList({ qpStatus: e })
    },
    toAddTopic() {
      /*const data = this.getQuestionTopicList_data.data;
      this.array = mapArr(this.theSelectedQtIds, id=>{
        return data.find(item=>item.qtId == id);
      });
      return;*/
      if (!this.theSelectedQtIds) return;
      var repeat = false;
      //先查询是否添加过---则跳过
      this.theSelectedQtIds.forEach(item => {
        var hasIn = false;
        this.array.forEach(elementOld => {
          if (item == elementOld.qtId) {
            !repeat && this.$message({
              message: '自动跳过已存在试题!',
              type: 'warning'
            });
            hasIn = repeat = true;
          };
        });
        if (!hasIn) {
          console.log("item===============" + item)
          //没有添加过执行添加
          this.getQuestionTopicList_data.data.forEach(element => {
            if (item == element.qtId) {
              this.array.push(element);
            }
          });
        }
      });
      //置空
      this.theSelectedQtIds = '';
    },
    myform(submit, Myformdata) {
      var arrayIds = [];
      this.array.forEach(element => {
        arrayIds.push(element.qtId);
      });
      Myformdata.questionTopicIdsString = arrayIds.join();
      Myformdata.qtgIds = Myformdata.qtgIds.join(',');
      submit();
    },
  },

  created() {
    this.getQuestionPaperList();
    this.getQuestionTopicList();
    this.getQuestionTopicGroupList()
    this.getMicrolectureList()
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/paper/PaperManage.vue